var APP_URL = 'https://lioncountry-gift-cards.herokuapp.com';

function gift_card_balance_check(form)
{
  $(".gc-balance-response").hide();
  
  $(form).find(".gc-balance-error").removeClass("gc-balance-error");
  
  var gc = jQuery.trim($(form).find("#gc").val());
  if(gc == "") $(form).find("#gc").addClass("gc-balance-error");
  
  //var gc_pin = jQuery.trim($(form).find("#gc-pin").val());
  var gc_pin = 888;
  if(gc_pin == "") $(form).find("#gc-pin").addClass("gc-balance-error");
  
  if(gc_pin == "" || gc == "")
    return false;

  let binMin = 7000000000000000000;
  let binMax = 7999999999999999999;
  
  //bin range and alpha check
  let gcCheck = parseFloat(gc);
  if(!gcCheck || gcCheck < binMin || gcCheck > binMax || !(/^\d+$/.test(gc))) {
    //$(form).find("#gc").addClass("gc-balance-error");
    //$(form).find("#gc-pin").addClass("gc-balance-error");
    $("#gc-balance-error").show();
    return false;
  }
  
  return gift_card_balance(gc, gc_pin);
}


function gift_card_balance(gc, gc_pin)
{
  button_loading();
  $.ajax({
    type: "GET",
    url: APP_URL + "/gift_cards/balance/" + gc + "/" + gc_pin,
    success: gift_card_balance_response,
    error: function(resp){ $("#gc-balance-error").show();},
    dataType: "json",
  });
  
  return false;
}

function gift_card_balance_response(gc_response)
{
  button_reset();
  if(gc_response.success == false)
  {
    $("#gc-balance-error").show();
  }
  else
  {
    $("#gc-balance-success").show();
    $("#gc-balance-amount").html(gc_response.balance);
  }
  console.log(gc_response);
}

/* utils */
function button_loading()
{  	
  var elem = $("#gift-card-balance-btn");
  $(elem).attr('data-default-text', $(elem).html());
  $(elem).addClass('data-loading');
  $(elem).html($(elem).attr('data-loading-text'));
  $(elem).prop("disabled", true);
}

function button_reset()
{
  var elem = $("#gift-card-balance-btn");
  $(elem).html($(elem).attr('data-default-text'));
  $(elem).removeClass('data-loading');
  $(elem).prop("disabled", false);
}

function ajax_error()
{
  button_reset();
  alert("Unable to check balance at this time.");
}